import { useStore } from 'effector-react'

import { $sellOffers, $totalCountOfSellOffers, getSellOfferList, sellOfferListMounted, } from './model'
import { SellOfferRequest } from './types'

export const useSellOfferList = () => {
  const onChangeSellOfferList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: SellOfferRequest) => {
    sellOfferListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const sellOffers = useStore($sellOffers)
  const totalCountOfSellOffers = useStore($totalCountOfSellOffers)
  const loading = useStore(getSellOfferList.pending)
  return {
    sellOffers,
    totalCountOfSellOffers,
    loading,
    onChangeSellOfferList,
  }
}
